import React from 'react'
import GeenWinesSizzle from "../assets/images/GeenWinesSizzlingDrink.jpg";
import GeenWinesStock from "../assets/images/Geen-wines-liquor-stock.jpg";
import GeenWinesDrinks from "../assets/images/Geen-wines-drinks-stock.jpg";


const AboutUs = () => {
  return (
    <>
<div className="lg:px-20 md:px-6 px-4 md:py-12 py-8">
  {/*- more free and premium Tailwind CSS components at https://tailwinduikit.com/ -*/}
  <div className="lg:flex items-center justify-between">
    <div className="lg:w-1/3">
      <h1 className="text-4xl font-bold leading-9 text-purple-800 dark:text-white">Booze Bodega</h1>
      <p className="text-base leading-6 mt-4 text-gray-600 dark:text-gray-100">Get inspired by our curated selection of luxiwood interiors. We hope get inspired to have luxiwood interior yourself. You’ll find tips here where you can buy a lot of cool furniture.</p>
      <button aria-label="view catalogue" className="focus:ring-2 focus:ring-offset-2 focus:ring-gray-700 focus:outline-none mt-6 md:mt-8 text-base font-semibold leading-none text-gray-800 dark:text-white flex items-center hover:underline">
        View Catalogue
        <svg className="ml-2 mt-1 dark:text-white" width={12} height={8} viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.33325 4H10.6666" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M8 6.66667L10.6667 4" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M8 1.33398L10.6667 4.00065" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </div>
    <div className="lg:w-7/12 lg:mt-0 mt-8">
      <div className="w-full h-full bg-red-200">
        <img src={GeenWinesStock} alt="apartment design" className="w-full sm:block hidden" />
      </div>
      <div className="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 lg:gap-8 gap-6 lg:mt-8 md:mt-6 mt-4">
        <img src={GeenWinesDrinks} className="w-full" alt="kitchen" />
        <img src={GeenWinesSizzle} className="w-full" alt="sitting room" />
      </div>
    </div>
  </div>
</div>

    </>
  )
}

export default AboutUs